import React from "react";

export default function EmbeddedPage(props) {
    return (
      <iframe className="embeddedPage" src={props.src}></iframe>
    );
  }
